import moment from 'moment';
import { useContext } from 'react';
import { DashboardResultsContext } from '../../DashboardResults.context';

export default () => {
  const { currentDates, setDateModalOpen } = useContext(DashboardResultsContext);

  const [from, to] = currentDates;

  return (
    <div
      className="dashboard__results-header-item dashboard__results-header-item--active"
      onClick={() => setDateModalOpen(true)}>
      <span>
        {moment(from).format('DD/MM/YYYY')} - {moment(to).format('DD/MM/YYYY')}
      </span>
    </div>
  );
};
